var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28878",
    "data-name": "Group 28878",
    transform: "translate(-31 -397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    transform: "translate(50 397) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.194,0a4,4,0,0,1,3.462,2L20.84,7.5a4,4,0,0,1,0,4.008L17.655,17a4,4,0,0,1-3.462,2H7.806a4,4,0,0,1-3.462-2L1.16,11.5a4,4,0,0,1,0-4.008L4.345,2A4,4,0,0,1,7.806,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.806209564208984 1.5 C 6.917130470275879 1.5 6.088109970092773 1.97797966003418 5.642650604248047 2.747400283813477 L 2.458440780639648 8.247409820556641 C 2.011129379272461 9.02003002166748 2.011129379272461 9.979960441589355 2.458429336547852 10.75259017944336 L 5.64263916015625 16.2525806427002 C 6.088100433349609 17.02202033996582 6.917130470275879 17.5 7.806209564208984 17.5 L 14.19379043579102 17.5 C 15.08287048339844 17.5 15.91189002990723 17.02202033996582 16.35734939575195 16.25259017944336 L 19.54155921936035 10.75257968902588 C 19.98887062072754 9.979960441589355 19.98887062072754 9.020039558410645 19.54155921936035 8.247409820556641 L 16.35734939575195 2.747409820556641 C 15.91189002990723 1.97797966003418 15.08287048339844 1.5 14.19379043579102 1.5 L 7.806209564208984 1.5 M 7.806209564208984 0 L 14.19379043579102 0 C 15.62113952636719 0 16.94034004211426 0.760589599609375 17.65549087524414 1.995859146118164 L 20.83970069885254 7.49586009979248 C 21.55743026733398 8.735569953918457 21.55743026733398 10.26443958282471 20.83970069885254 11.50413990020752 L 17.65549087524414 17.00414085388184 C 16.94034004211426 18.23941040039062 15.62113952636719 19 14.19379043579102 19 L 7.806209564208984 19 C 6.378860473632812 19 5.059659957885742 18.23941040039062 4.344499588012695 17.00414085388184 L 1.160289764404297 11.50413990020752 C 0.4425697326660156 10.26443004608154 0.4425697326660156 8.735560417175293 1.160299301147461 7.495849609375 L 4.344509124755859 1.995849609375 C 5.059659957885742 0.760589599609375 6.378860473632812 0 7.806209564208984 0 Z",
    stroke: "none",
    fill: "#4b74be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28875",
    "data-name": "Group 28875",
    transform: "translate(-58.975 277.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65883",
    "data-name": "Path 65883",
    d: "M100.156,136.431h2.75a1.8,1.8,0,0,0,1.8-1.8h0a1.8,1.8,0,0,0-1.8-1.8h-.948a1.8,1.8,0,0,1-1.8-1.8h0a1.8,1.8,0,0,1,1.8-1.8h2.749",
    transform: "translate(-2.493 -1.835)",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5059",
    "data-name": "Line 5059",
    y2: 1.748,
    transform: "translate(99.939 134.596)",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5060",
    "data-name": "Line 5060",
    y2: 1.748,
    transform: "translate(99.939 125.644)",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancesActive);
export default __webpack_public_path__ + "static/media/FinancesActive.03a36a45e84f105829f0b2677390661c.svg";
export { ForwardRef as ReactComponent };